import yup from 'yup'
import axios from 'axios'

function getCreateBasicProfileValidationSchema (expert) {
  let passwordSchema = yup
        .string()
        .min(8, 'Password must be at least 8 characters long')
        .max(64, 'Password must be at most 64 characters long')
        .matches(
          /(?=.*[0-9].*)(?=.*[a-z].*)/,
          'Password must contain at least one letter and number'
        )
        .nullable()

  let passwordConfirmation = yup.string()
  .test('passwords-match', 'Passwords must match', function(value){
    return this.parent.password === value
  })
      
  return yup.object().shape({
    phoneNum: yup.string().matches(/^[0-9\-+/\s]*$/, 'Phone number format is invalid').nullable(),
    phoneTypeId: yup.number(),
    password: passwordSchema,
    passwordConfirmation: passwordConfirmation,
    email: yup
      .string()
      .email('Email format is invalid')
      .test('unique', 'Invalid email', value => {
        if (
          yup
            .string()
            .email()
            .isValidSync(value)
        ) {
          if (!value) return true // fallback to required error
          let payload = { email: value }
          if (expert) {
            payload = { ...payload, id: expert.id }
          }
          return axios
            .post('/api/email-check', payload)
            .then(res => res.data.valid)
            .catch(_ => false)
        }
      return true
    }).required('Email is required'),
    latestExperiences: yup.array()
      .of(
        yup.object().shape({
          position: yup.string().nullable(),
          company: yup.string().nullable(),
          startDate: yup.string().nullable(),
          endDate: yup.string().nullable(),
          current: yup.boolean().nullable(),
          description: yup.string().nullable()
        })
      )
    })
}

export default getCreateBasicProfileValidationSchema
